import ng from "angular"
import { ReviewItemId } from "../../models/ReviewItem"
import { NoteStatus, ReviewService } from '../../services/ReviewService'


class ApplicationFormReviewDirective implements ng.IDirective {
    restrict = 'AE'
    controller = ApplicationFormReviewController
    controllerAs = 'arCtrl'
    bindToController = true
    templateUrl = 'controls/applicationFormReview/applicationFormReview.html'
    scope = {
        review: '=applicationFormReview',
        applicationId: '=',
        itemType: '=',
        referenceId: '=',
        assignId:'=',
        applicationFormOptions: '=applicationFormOptions'
    }
}

class ApplicationFormReviewController {
    //referenceId todo
    review: ReviewService
    public alerts: Array<Object> = []
    applicationId: number;
    formHeading: string;
    itemId: number;
    itemType: string;
    referenceId: number;
    assignId: number;
    isOfficeUser: boolean;
    applicationFormOptions: any;
    author: string;

    static $inject = ['$scope', 'Auth', 'ApproveChanges', 'RevertSection', 'dialogs']; 
    constructor(private $scope, private Auth, private ApproveChanges, private RevertSection, private dialogs) { 
        var user = this.Auth.user;
        this.isOfficeUser = user.isOfficer?? false;

        this.author = user.firstName + ' ' + user.lastName;
        this.itemId = ReviewItemId[<string>this.itemType];
    }

    showApproveButton() {
        var itemId = ReviewItemId[this.itemType];
        if (this.assignId > 0) {
            var dceNoteStatus = this.review.getReviewableItemNote(itemId, this.assignId);
            var dceReviewStatus = this.review.getApproveItemDeclineStatus(itemId, this.assignId);

            return dceNoteStatus.approveChange || (dceNoteStatus.note.status === 1 && !dceReviewStatus.sectionDeclined && !dceNoteStatus.approveChange);
        }

        return this.review.getApproveItemStatus(itemId);
    }

    showDeclineButton() {
        var itemId = ReviewItemId[this.itemType];
        if (this.assignId > 0) {
            var dceNoteStatus = this.review.getReviewableItemNote(itemId, this.assignId);
            var dceReviewStatus = this.review.getApproveItemDeclineStatus(itemId, this.assignId);

            return dceNoteStatus.approveChange &&
                (((itemId == ReviewItemId.DocumentedChildcareExperience && this.assignId > 0) ||
                    (itemId == ReviewItemId.EducationAndWorkHistory && this.assignId > 0)) &&
                    (dceNoteStatus.note && dceNoteStatus.note.assignId === this.assignId &&
                        (dceNoteStatus.note.status === 1 && !dceReviewStatus.sectionDeclined))
                );
        }

        return (this.showApproveButton() && (
            itemId != ReviewItemId.Media &&
            itemId != ReviewItemId.FuturePlans &&
            itemId != ReviewItemId.References &&
            itemId != ReviewItemId.DocumentedChildcareExperience &&
            itemId != ReviewItemId.EducationAndWorkHistory)
        );
    }

    changesApproved() {
        var data = {
            applicationId: this.applicationId,
            item: this.itemType, 
            assignId: this.assignId,
            author: this.author
        };

        this.ApproveChanges
            .update({ applicationId: this.applicationId }, data)
            .$promise
            .then(data => {
                
                //refresh page
                window.location.reload();

                //this.alerts.push({
                //    type: 'success',
                //    msg: 'Approval complete',
                //    dismissOnTimeout: 5000
                //});
            }, () => {
                //this.alerts.push({
                //    type: 'danger',
                //    msg: 'We are sorry but this form could not be approved. Please try again in 5 minutes. <br /> If this problem continues, please contact us at: <a target= "_blank" href= "mailto:support@aupairamerica.co.uk" > support@aupairamerica.co.uk</a>',
                //    dismissOnTimeout: 20000
                //});
            });
    }

    declineChanges() {

        this.RevertSection.decline({
            applicationId: this.applicationId,
            itemId: this.itemType,
            assignId: this.assignId,
            //assignId: this.conf.assignId,
            author: this.author
        }, (result) => {
            //refresh page
            window.location.reload();
        }, (err) => {
            if(err.status === 404){
                this.dialogs.error('Internal error', 'Error occured while attempting to reject this section. Please try again later.');
            }
        });
    }
}


angular
    .module('app')
    .directive('applicationFormReview', () => new ApplicationFormReviewDirective());